export default "__VITE_ASSET__4254fa36__"